import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOsWindows = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Brand and services logos / Microsoft (logo)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Icon",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M2 2H11.5039V11.5039H2V2Z",
					fill: "#F25022"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.4961 2H22V11.5039H12.4961V2Z",
					fill: "#7FBA00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2 12.4961H11.5039V22H2V12.4961Z",
					fill: "#00A4EF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.4961 12.4961H22V22H12.4961V12.4961Z",
					fill: "#FFB900"
				})
			]
		})
	})
});
export default SvgOsWindows;
